import { ref } from 'vue'
import { chatNamesMatch } from '@shared/index'
import { useChatStore } from '../stores/chat'
import { useChatMuteStore } from '../stores/chatMutes'
import { rankedCallOffers } from '../game/net/rankedCall'

/** Latest public rename. Components that hold their own copies watch this. */
export const accountRename = ref<{
  previous: string
  username: string
  id: number
} | null>(null)

let seq = 0

export function readAccountRename(
  payload: unknown,
): { previous: string; username: string } | null {
  if (!payload || typeof payload !== 'object') return null
  const previous = (payload as { previous?: unknown }).previous
  const username = (payload as { username?: unknown }).username
  if (typeof previous !== 'string' || typeof username !== 'string') return null
  const from = previous.trim()
  const to = username.trim()
  if (!from || !to || from === to) return null
  return { previous: from, username: to }
}

/**
 * Rewrites duel chat, the queue chips, and notifies open panels.
 * Safe to run twice for the same pair.
 */
export function publishClientRename(previous: string, username: string): void {
  if (!previous || previous === username) return
  useChatStore().applyRename(previous, username)
  useChatMuteStore().applyRename(previous, username)
  const offers = rankedCallOffers.value
  let offersChanged = false
  const nextOffers = offers.map((row) => {
    if (!chatNamesMatch(row.username, previous)) return row
    offersChanged = true
    return { ...row, username }
  })
  if (offersChanged) rankedCallOffers.value = nextOffers
  accountRename.value = { previous, username, id: ++seq }
}
